const programs = [
    {
        id: 1,
        day: "22nd October 2024",
        time: "4:00 pm - 6:00 pm",
        event: "Registration",
        theme: "General",
        venue: "Main Hall",
    },
    {
        id: 2,
        day: "22nd October 2024",
        time: "4:30 pm - 5:30 pm",
        event: "Press Conference",
        theme: "General",
        venue: "Conference Room",
    },
    {
        id: 3,
        day: "22nd October 2024",
        time: "6:00 pm - 8:00 pm",
        event: "Visit to C3iHub R&D Centre",
        theme: "Visit",
        venue: "C3iHub",
    },
    {
        id: 4,
        day: "22nd October 2024",
        time: "8:00 pm onwards",
        event: "Gala Dinner",
        theme: "Dinner",
        venue: "Banquet Hall",
    },
    {
        id: 5,
        day: "23rd October 2024",
        time: "9:00 am – 10:30 am",
        event: "Inauguration of Conference and Exhibition Stalls",
        theme: "Inauguration",
        venue: "Main Hall",
    },
    {
        id: 6,
        day: "23rd October 2024",
        time: "10:30 am - 11:00 am",
        event: "Tea Break & Group Photo",
        theme: "Break",
        venue: "Garden Area",
    },
    {
        id: 7,
        day: "23rd October 2024",
        time: "11:00 am - 12:00 pm",
        event: "Keynote 1: Post-Quantum Cryptography",
        theme: "PQC",
        venue: "Room 1",
    },
    {
        id: 8,
        day: "23rd October 2024",
        time: "12:00 pm - 12:40 pm",
        event: "Invited Talk 1 PQC",
        theme: "PQC",
        venue: "Room 1",
    },
    {
        id: 9,
        day: "23rd October 2024",
        time: "12:40 pm - 1:20 pm",
        event: "Invited Talk 2 PQC",
        theme: "PQC",
        venue: "Room 1",
    },
    {
        id: 10,
        day: "23rd October 2024",
        time: "1:20 pm - 2:20 pm",
        event: "Lunch",
        theme: "Lunch",
        venue: "Dining Hall",
    },
    {
        id: 11,
        day: "23rd October 2024",
        time: "2:20 pm – 3:00 pm",
        event: "Invited Talk 3 PQC",
        theme: "PQC",
        venue: "Room 1",
    },
    {
        id: 12,
        day: "23rd October 2024",
        time: "3:00 pm – 4:00 pm",
        event: "Panel Discussion PQC",
        theme: "PQC",
        venue: "Room 2",
    },
    {
        id: 13,
        day: "23rd October 2024",
        time: "4:00 pm – 5:00 pm",
        event: "Keynote 2: Advanced Persistent Threat (APT)",
        theme: "APT",
        venue: "Room 1",
    },
    {
        id: 14,
        day: "23rd October 2024",
        time: "5:00 pm – 5:30 pm",
        event: "Tea Break",
        theme: "Break",
        venue: "Garden Area",
    },
    {
        id: 15,
        day: "23rd October 2024",
        time: "5:30 pm - 6:10 pm",
        event: "Invited Talk 1 APT",
        theme: "APT",
        venue: "Room 1",
    },
    {
        id: 16,
        day: "23rd October 2024",
        time: "6:10 pm - 6:50 pm",
        event: "Invited Talk 2 APT",
        theme: "APT",
        venue: "Room 1",
    },
    {
        id: 17,
        day: "23rd October 2024",
        time: "7:30 pm",
        event: "Dinner",
        theme: "Dinner",
        venue: "Banquet Hall",
    },
    {
        id: 18,
        day: "24th October 2024",
        time: "9:00 am - 9:40 am",
        event: "Invited Talk 3 APT",
        theme: "APT",
        venue: "Room 1",
    },
    {
        id: 19,
        day: "24th October 2024",
        time: "9:40 am - 10:40 am",
        event: "Panel Discussion APT",
        theme: "APT",
        venue: "Room 2",
    },
    {
        id: 20,
        day: "24th October 2024",
        time: "10:40 am - 11:10 am",
        event: "Tea Break",
        theme: "Break",
        venue: "Garden Area",
    },
    {
        id: 21,
        day: "24th October 2024",
        time: "11:10 am - 12:10 pm",
        event: "Keynote 3: Supply Chain Security",
        theme: "Supply Chain Security",
        venue: "Room 1",
    },
    {
        id: 22,
        day: "24th October 2024",
        time: "12:10 pm - 12:50 pm",
        event: "Invited Talk 1 Supply Chain Security",
        theme: "Supply Chain Security",
        venue: "Room 1",
    },
    {
        id: 23,
        day: "24th October 2024",
        time: "12:50 pm - 1:30 pm",
        event: "Invited Talk 2 Supply Chain Security",
        theme: "Supply Chain Security",
        venue: "Room 1",
    },
    {
        id: 24,
        day: "24th October 2024",
        time: "1:30 pm - 2:30 pm",
        event: "Lunch",
        theme: "Lunch",
        venue: "Dining Hall",
    },
    {
        id: 25,
        day: "24th October 2024",
        time: "2:30 pm - 3:10 pm",
        event: "Invited Talk 3 Supply Chain Security",
        theme: "Supply Chain Security",
        venue: "Room 1",
    },
    {
        id: 26,
        day: "24th October 2024",
        time: "3:10 pm - 4:10 pm",
        event: "Panel Discussion on Supply Chain Security",
        theme: "Supply Chain Security",
        venue: "Room 2",
    },
    {
        id: 27,
        day: "24th October 2024",
        time: "4:10 pm - 4:40 pm",
        event: "Tea Break",
        theme: "Break",
        venue: "Garden Area",
    },
    {
        id: 28,
        day: "24th October 2024",
        time: "4:40 pm - 5:40 pm",
        event: "Keynote 4: Electronic Warfare",
        theme: "Electronic Warfare",
        venue: "Room 1",
    },
    {
        id: 29,
        day: "24th October 2024",
        time: "5:40 pm - 6:20 pm",
        event: "Invited Talk 1 Electronic Warfare",
        theme: "Electronic Warfare",
        venue: "Room 1",
    },
    {
        id: 30,
        day: "24th October 2024",
        time: "6:20 pm onwards",
        event: "Launch of Defence DIAL Program",
        theme: "Cybersecurity",
        venue: "Room 2",
    },
    {
        id: 31,
        day: "24th October 2024",
        time: "7:30 pm",
        event: "Dinner",
        theme: "Dinner",
        venue: "Banquet Hall",
    },
    {
        id: 32,
        day: "25th October 2024",
        time: "10:00 am - 10:40 am",
        event: "Invited Talk 2 Electronic Warfare",
        theme: "Electronic Warfare",
        venue: "Room 1",
    },
    {
        id: 33,
        day: "25th October 2024",
        time: "10:40 am - 11:20 am",
        event: "Invited Talk 3 Electronic Warfare",
        theme: "Electronic Warfare",
        venue: "Room 1",
    },
    {
        id: 34,
        day: "25th October 2024",
        time: "11:20 am - 11:50 am",
        event: "Tea Break",
        theme: "Break",
        venue: "Garden Area",
    },
    {
        id: 35,
        day: "25th October 2024",
        time: "11:50 am - 12:50 pm",
        event: "Panel Discussion on Electronic Warfare",
        theme: "Electronic Warfare",
        venue: "Room 2",
    },
    {
        id: 36,
        day: "25th October 2024",
        time: "12:50 pm - 1:30 pm",
        event: "Lunch",
        theme: "Lunch",
        venue: "Dining Hall",
    },
    {
        id: 37,
        day: "25th October 2024",
        time: "1:30 pm - 3:00 pm",
        event: "Breakout of Electronic Warfare",
        theme: "Electronic Warfare",
        venue: "Room 2",
    },
    {
        id: 38,
        day: "25th October 2024",
        time: "3:00 pm - 4:00 pm",
        event: "Valedictory Session",
        theme: "General",
        venue: "Main Hall",
    },
];

export const initialProgramSchedule = [
    {
        id: 1,
        day: "22nd October 2024",
        time: "4:00 PM onwards",
        event: ["Registration", "Visit to C3iHub R&D Center"],
        theme: "General",
        venue: "Main Hall",
    },
    {
        id: 2,
        day: "23rd October 2024",
        time: "9:00 AM onwards",
        event: [
            "Inaugural Session",
            "Plenary Talk",
            "Session on Electronic Warfare",
            "Session on Post-Quantum Cryptography",
            "R&D and Start-up Showcase Visit",
            // "R&D and Start-up Demonstration Stalls"
        ],
        theme: "Cybersecurity",
        venue: "Main Hall",
    },
    {
        id: 3,
        day: "24th October 2024",
        time: "9:00 AM onwards",
        event: ["Session on Post-Quantum Cryptography (Continued)", "Session on Supply Chain Security", "Session on Advanced Persistent Threat", "Start-up VC Pitch"],
        theme: "Cybersecurity",
        venue: "Main Hall",
    },
    {
        id: 4,
        day: "25th October 2024",
        time: "10:00 AM onwards",
        event: ["Session on Advanced Persistent Threat (Continued)", "Valedictory Session"],
        theme: "Cybersecurity",
        venue: "Main Hall",
    },
];

export default programs;
